import { render, staticRenderFns } from "./PriceScheduleForm.vue?vue&type=template&id=f887b7d6&scoped=true&"
import script from "./PriceScheduleForm.vue?vue&type=script&lang=js&"
export * from "./PriceScheduleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f887b7d6",
  null
  
)

export default component.exports